import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbNavModule, NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { SvgIconComponent } from 'angular-svg-icon';
import { environment } from '../../../../../../environments/environment';
import { InputTextModule } from 'primeng/inputtext';
import { LessonsService } from '../../../_services/lessons.service';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../../../core/core.module';
import { TeacherService } from '../../../_services/teacher.service';
import { ChapterService } from '../../../_services/chapter.service';
import { AssignmentService } from '../../../_services/assignment.service';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthService } from '../../../../auth/_services/auth.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { Utility } from '../../../../core/utils/utility';
import { StartupProfileService } from '../../../../panel/_services/startup-profile.service';
import { CourseService } from '../../../_services/course.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-session-detailes',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    NgbNavModule,
    SvgIconComponent,
    InputTextModule,
    ConfirmDialogModule,
    DropdownModule,
    CoreModule,
  ],
  templateUrl: './session-detailes.component.html',
  styleUrl: './session-detailes.component.scss',
  providers: [ConfirmationService]
})
export class SessionDetailesComponent {
  fileServerUrl = environment.fileServerUrl;
  defaultAvatar = environment.defaultAvatar;
  profileImageUrl = environment.defaultAvatar;
  session: any;
  teacher: any;
  teacherUniversity: any;
  teacherLearners: any;
  chapter: any;
  id!: string | null;
  index: any;
  prevLesson: any;
  nextLesson: any;
  completedCount: any;
  assignments: any;
  myForm: FormGroup;
  loading: boolean = false;

  // Admin startup selection properties
  dataStartups: any[] = [];
  selectedStartupId: string | null = null;
  selectedStartup: any = null;
  loadingStartups: boolean = false;
  showStartupDropdown: boolean = false;
  isPreviewMode: boolean = false;

  get assignmentsForm() {
    return this.myForm.get('assignments') as FormArray;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private lessonService: LessonsService,
    private teacherService: TeacherService,
    private chapterService: ChapterService,
    private courseService: CourseService,
    private assignmentService: AssignmentService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private startupService: StartupProfileService
  ) {
    route.paramMap.subscribe(params => {
      this.session = null;
      this.id = params.get('id');
      lessonService.getById(this.id as any as number).subscribe(res => {
        this.session = res;

        teacherService.getById(this.session.teacherId).subscribe(res => {
          this.teacher = res;
          this.teacherUniversity = this.teacher?.resume?.educationalRecords?.length ? this.teacher?.resume?.educationalRecords[0].universityRefTitle : '';
          this.teacherLearners = this.teacher.courses.map((x: any) => x.studentCount).reduce((partialSum: number, a: number) => partialSum + a, 0);
        });

        chapterService.getById(this.session.chapterId).subscribe((res: any) => {
          this.chapter = res;
          this.index = this.chapter.lessons.findIndex((x: any) => x.id == this.id);
          try { this.prevLesson = this.chapter.lessons[this.index - 1]; } catch { }
          try { this.nextLesson = this.chapter.lessons[this.index + 1]; } catch { }

          this.completedCount = this.chapter.lessons.filter((x: any) => x.isViewed)?.length;
        });

        assignmentService.get({ lessonId: this.id }).subscribe((res: any) => {
          this.assignments = res.result;
          this.assignments.forEach((x: any, i: number) => {
            if (new Date(x.dueDate) < new Date()) {
              x.locked = true;
            }

            (<FormArray>this.assignmentsForm).push(fb.group({
              assignmentId: x.id,
              scopeId: route.snapshot.queryParamMap.get('startupid') || '',
              attachments: this.fb.array([]),
            }));
          })

          if (authService.isInRole('Founder')) {
            this.startupService.getForedit(route.snapshot.queryParamMap.get('startupid')).subscribe(startup => {

              assignmentService.getHomeworks(res.result.map((x: any) => x.id), startup?.members?.map((x: any) => x.id), route.snapshot.queryParamMap.get('startupid')).subscribe((r: any) => {
                for (const key in r) {
                  this.assignments.find((x: any) => x.id == key).attachments = r[key].homeWorks;
                }
              })
            })
          } else if ((this.authService.isAdmin || this.authService.isTenantAdminOrOperator) && route.snapshot.queryParamMap.get('startupid')) {
            // Admin viewing startup session - get homework they submitted on behalf of startup members
            this.selectedStartupId = route.snapshot.queryParamMap.get('startupid');
            assignmentService.getHomeworks(res.result.map((x: any) => x.id), null, route.snapshot.queryParamMap.get('startupid')).subscribe((r: any) => {
              for (const key in r) {
                this.assignments.find((x: any) => x.id == key).attachments = r[key].homeWorks;
              }
            })
          } else if (this.authService.isAdmin || this.authService.isTenantAdminOrOperator) {
            // Admin without startup parameter - show dropdown to select startup
            this.showStartupDropdown = true;
            this.loadStartupsForProgram();
          }
        });
      });
    })

    route.queryParamMap.subscribe(params => {
      if (params.get('preview')) {
        this.isPreviewMode = true;
      }

       if(route.snapshot.queryParamMap.get('startupid')){
         this.assignments.forEach((x: any, i: number) => {
            if (new Date(x.dueDate) < new Date()) {
              x.locked = true;
            }

            x.attachments = [];

            (<FormArray>this.assignmentsForm).push(fb.group({
              assignmentId: x.id,
              scopeId: route.snapshot.queryParamMap.get('startupid') || '',
              attachments: this.fb.array([]),
            }));
          })

          if (authService.isInRole('Founder')) {
            this.startupService.getForedit(route.snapshot.queryParamMap.get('startupid')).subscribe(startup => {

              assignmentService.getHomeworks(this.assignments.map((x: any) => x.id), startup?.members?.map((x: any) => x.id), route.snapshot.queryParamMap.get('startupid')).subscribe((r: any) => {
                for (const key in r) {
                  this.assignments.find((x: any) => x.id == key).attachments = r[key].homeWorks;
                }
              })
            })
          } else if ((this.authService.isAdmin || this.authService.isTenantAdminOrOperator) && route.snapshot.queryParamMap.get('startupid')) {
            // Admin viewing startup session - get homework they submitted on behalf of startup members
            this.selectedStartupId = route.snapshot.queryParamMap.get('startupid');
            assignmentService.getHomeworks(this.assignments.result.map((x: any) => x.id), null, route.snapshot.queryParamMap.get('startupid')).subscribe((r: any) => {
              for (const key in r) {
                this.assignments.find((x: any) => x.id == key).attachments = r[key].homeWorks;
              }
            })
          } else if (this.authService.isAdmin || this.authService.isTenantAdminOrOperator) {
            // Admin without startup parameter - show dropdown to select startup
            this.showStartupDropdown = true;
            this.loadStartupsForProgram();
          }
      }
    });

    this.myForm = this.fb.group({
      assignments: fb.array([])
    });
  }

  onSelectAttachment(event: any, i: number) {
    const files: FileList = event.target.files;
    if (files) {
      for (let index = 0; index < files.length; index++) {
        const file = files[index];
        (<FormArray>this.assignmentsForm.controls[i].get('attachments'))?.push(new FormControl(file));
      }
    }
  }

  removeAttachment(index: number, i: number) {
    (<FormArray>this.assignmentsForm.controls[i].get('attachments')).removeAt(index);
  }

  deleteAttachment(item: any, index: number, e: any, i: number) {
    this.confirmationService.confirm({
      target: e.target as EventTarget,
      message: 'Are you sure you want to proceed?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.assignmentService.deleteHomeWorkAttachment(item.id).subscribe((_: any) => {
          this.assignments[i].attachments.splice(index, 1);
        })
      },
      reject: () => {
      }
    });
  }

  downloadAssignmentTemplate(id: number) {
    this.assignmentService.downloadAssignment(id).subscribe(res => {
      const downloadedFile = new Blob([res], { type: res.type });
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      a.href = URL.createObjectURL(downloadedFile);
      a.target = '_blank';
      a.click();
      document.body.removeChild(a);
    })
  }


  download(item: any) {
    this.assignmentService.getHomeworkAttachment(item.id).subscribe(res => {
      const downloadedFile = new Blob([res], { type: res.type });
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      if (!Utility.isPhoto(item.originalFileName))
        a.download = item.originalFileName;
      a.href = URL.createObjectURL(downloadedFile);
      a.target = '_blank';
      a.click();
      document.body.removeChild(a);
    })
  }

  onSubmit(i: number) {
    if (!this.myForm.value.assignments[i].attachments?.length) {
      this.messageService.add({ detail: 'Please select files to upload.', severity: 'warn' });
      return;
    }

    this.loading = true;
    const submissionData = { ...this.myForm.value.assignments[i] };

    // Handle admin submission with startup selection
    if (this.authService.isAdmin || this.authService.isTenantAdminOrOperator) {
      const startupId = this.selectedStartupId || this.route.snapshot.queryParamMap.get('startupid');
      if (!startupId && this.showStartupDropdown) {
        this.messageService.add({
          detail: 'Please select a startup to upload homework on their behalf.',
          severity: 'warn'
        });
        return;
      }
      if (startupId) {
        submissionData.scopeId = startupId;
      }
    }

    this.assignmentService.submitHomework(submissionData).subscribe((res: any) => {
      this.loading = false;
      this.messageService.add({ detail: 'Homework submitted successfully.', severity: 'success' });
    }, err => {
      this.loading = false;
      this.messageService.add({ detail: 'There was a problem submitting Homework.', severity: 'error' });
    })
  }

  // Load startups connected to the current program for admin selection
  loadStartupsForProgram() {
    if (!this.session?.courseId) return;

    this.loadingStartups = true;
    this.courseService.getStartupCourseForAdmin({
      filter: {
        courseId: this.session.courseId,
        tenantId: localStorage.getItem('tenantId') ?? JSON.parse(localStorage.getItem('tenant') as string)?.id
      },
      paginator: { pageIndex: 0, pageSize: 1000000 }
    }).subscribe({
      next: (response: any) => {
        this.dataStartups = response.result || [];
        this.loadingStartups = false;

        // Auto-select if only one startup
        if (this.dataStartups.length === 1) {
          this.selectedStartup = this.dataStartups[0];
          this.selectedStartupId = this.dataStartups[0].startupId;
          this.onStartupSelect();
        }
      },
      error: (error) => {
        console.error('Error loading startups:', error);
        this.loadingStartups = false;
        this.messageService.add({
          detail: 'Failed to load startups for this program.',
          severity: 'error'
        });
      }
    });
  }

  // Handle startup selection change from dropdown
  onDropdownChange(event: any) {
    this.selectedStartup = event.value;
    this.selectedStartupId = event.value?.startupId;
    this.onStartupSelect();
  }

  // Handle startup selection change
  onStartupSelect() {
    if (!this.selectedStartupId) return;

    // Update form scopeId for all assignments
    if (this.myForm?.value?.assignments) {
      this.myForm.value.assignments.forEach((assignment: any, index: number) => {
        const assignmentFormGroup = this.assignmentsForm.at(index);
        assignmentFormGroup?.get('scopeId')?.setValue(this.selectedStartupId);
      });
    }

    // Load homework for the selected startup
    this.loadHomeworkForSelectedStartup();
  }

  // Load homework data for the selected startup
  loadHomeworkForSelectedStartup() {
    if (!this.selectedStartupId || !this.assignments?.length) return;

    const assignmentIds = this.assignments.map((x: any) => x.id);
    this.assignmentService.getHomeworks(assignmentIds, null, this.selectedStartupId).subscribe((r: any) => {
      for (const key in r) {
        const assignment = this.assignments.find((x: any) => x.id == key);
        if (assignment) {
          assignment.attachments = r[key].homeWorks;
        }
      }
    });
  }
}
